import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Payroll } from '../../modules/ComponentsLibrary/Payroll';

export const Route = createFileRoute('/payroll/')({
  component: RouteComponent,
  validateSearch: z.object({
    tab: z.string().optional(),
  }),
  head() {
    return {
      meta: [{ title: 'Payroll' }],
    };
  },
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  return <Payroll initialTab={tab} />;
}
